<app-navigation [class]="themeClass()"></app-navigation>
